<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import type { DialogEvents } from "@/components/mixins/dialogs";
import { useReactiveDialogScriptSetup } from "@/components/mixins/dialogs";
import { toRef } from "vue";

export interface DataCellInfoDialogProps {
  value: boolean;
  infoToDisplay: string;
}
export interface DataCellInfoDialogEvents extends DialogEvents {}

const props = defineProps<DataCellInfoDialogProps>();
const emit = defineEmits<DataCellInfoDialogEvents>();

const { accept, cancel } = useReactiveDialogScriptSetup(
  toRef(props, "value"),
  emit
);
</script>

<template>
  <bm-dialog v-bind="$attrs" :visible="value" @accept="accept" @cancel="cancel">
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="(text, index) in infoToDisplay.split('\n')"
          :key="index"
          cols="12"
        >
          {{ text }}
        </v-col>
      </v-row>
    </v-container>
    <template #controls-cancel-text>
      {{ $m.cancel }}
    </template>
    <template #controls-confirm-text>
      {{ $m.ok }}
    </template>
  </bm-dialog>
</template>
